import { render, staticRenderFns } from "./UserClinicDeleteModal.vue?vue&type=template&id=12990bf8&scoped=true"
import script from "./UserClinicDeleteModal.vue?vue&type=script&lang=js"
export * from "./UserClinicDeleteModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12990bf8",
  null
  
)

export default component.exports